/**
 * HintRow Component
 * Inline icon + text row for hints, privacy notices, and subtle info messages.
 * Uses brand primary color by default to match primary action styling.
 */

import { type ReactNode } from 'react';
import { designTokens } from '../../constants/designTokens';

interface HintRowProps {
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  tone?: 'brand' | 'secondary';
}

export function HintRow({
  icon,
  children,
  className = '',
  tone = 'brand',
}: HintRowProps) {
  return (
    <>
      <div className={`hint-row hint-row-${tone} ${className}`}>
        {icon && <span className="hint-row-icon">{icon}</span>}
        <span className="hint-row-text">{children}</span>
      </div>

      <style>{`
        .hint-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: ${designTokens.spacing.sm};
          font-size: ${designTokens.typography.fontSize.sm};
          text-align: center;
        }

        .hint-row-brand {
          color: ${designTokens.colors.brand.primary};
        }

        .hint-row-secondary {
          color: ${designTokens.colors.text.secondary};
        }

        .hint-row-icon {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }

        .hint-row-text {
          line-height: ${designTokens.typography.lineHeight.normal};
        }

        ${designTokens.media.mobile} {
          .hint-row {
            font-size: ${designTokens.typography.fontSize.xs};
          }
        }
      `}</style>
    </>
  );
}
